import { createSelector } from 'reselect';
import { CommunicationTypes } from '../../constants';

export const announcementsSelector = createSelector(
  state => state.dashboard.communications.communications,
  communications => communications.filter(({ type }) => type === CommunicationTypes.ANNOUNCEMENT)
);
